import BreakDeposit from '@/views/accounts/termDepositActions/BreakDeposit.vue'
import AmendDeposit from '@/views/accounts/termDepositActions/AmendDeposit.vue'

export default {
  BreakDeposit,
  AmendDeposit
}
